/**
 * Selection rules for the simulated-suggestion integration picker.
 *
 * Kept separate from the modal so the cap and filter behaviour can be tested
 * without rendering a dialog. The cap is enforced again server-side; this is
 * the interaction guard, not the security boundary.
 */
import type { SuggestionSource } from '../../api/client';

/**
 * toggleSource adds or removes a source, refusing to grow the selection past
 * the cap. Returns the same array reference when nothing changes so callers can
 * rely on referential equality.
 */
export function toggleSource(selected: string[], source: string, maxSources: number): string[] {
  if (selected.includes(source)) return selected.filter(s => s !== source);
  if (selected.length >= maxSources) return selected;
  return [...selected, source];
}

/** filterSources matches on both the display label and the underlying key. */
export function filterSources(sources: SuggestionSource[], query: string): SuggestionSource[] {
  const q = query.trim().toLowerCase();
  if (!q) return sources;
  return sources.filter(
    s => s.label.toLowerCase().includes(q) || s.source.toLowerCase().includes(q),
  );
}
